import {action, computed, makeObservable, observable} from "mobx";
import CommonStore from "../../stores/CommonStore";
import { ArticleDeliveryService } from "../../service/productOrder/ArticleDeliveryService";
import ArticleDeliveryOrderResponse from "../../model/productOrder/articleDelivery/ArticleDeliveryOrderResponse";
import UserStore from "../../stores/UserStore";
import Geo from "../../entities/Geo";

class ArticleDeliveryStore {

    public articleRemittances: ArticleDeliveryOrderResponse[];
    public selectedArticleRemittanceIds: string[];

    public filter?: string;
    public fromFilter: number | undefined;
    public toFilter: number | undefined;
    public geoFilter?: Geo;

    public commonStore: CommonStore;
    public userStore: UserStore;

    constructor(commonStore: CommonStore, userStore: UserStore) {
        this.articleRemittances = [];
        this.selectedArticleRemittanceIds = [];
        this.commonStore = commonStore;
        this.userStore = userStore;
        makeObservable(this, {
            selectedArticleRemittanceIds: observable,
            articleRemittances: observable,
            isEmpty: computed
        });
        
    }

    get isEmpty(): boolean {
        return this.articleRemittances.length === 0;
    }

    public setFilter(filter: string) {
        this.filter = filter;
    }

    public setFromFilter(from?: number) {
        this.fromFilter = from;
    }

    public setToFilter(to?: number) {
        this.toFilter = to;
    }

    public setGeoFilter(newGeo?: Geo) {
        this.geoFilter = newGeo;
    }

    @action
    public async clearFilter() {
        this.geoFilter = undefined;
        this.fromFilter = undefined;
        this.toFilter = undefined;
        this.filter = undefined;
        await this.getElements();
    }

    @action
    public async search() {
        await this.getElements();
    }

    @action
    public async getElements(): Promise<void> {
        this.commonStore.setLoading();
        const response = await ArticleDeliveryService.get(
            this.fromFilter,
            this.toFilter,
            this.userStore.currentUser()?.id,
            this.filter,
            this.geoFilter?.id
        );
        this.articleRemittances = response;
        this.commonStore.removeLoading();
    }

}

export default ArticleDeliveryStore;